import { MAPPING_VCENTER_FIELD, MAPPING_VCENTER_UUID_FIELD } from '../InfrastructureConstants';
import { InfrastructureLink } from '../InfrastructureLinkUtils';

/**
 * Displays a drill-in link to the vCenter detail page
 * Shows invalid value placeholder if vCenter data is missing
 */
const VcenterLink = () => {
    return <InfrastructureLink nameField={MAPPING_VCENTER_FIELD} idField={MAPPING_VCENTER_UUID_FIELD} />;
};

export default VcenterLink;
